<script lang="ts">
  import './css/header.scss';
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import type { Header } from '../types';
  import type { MktSettings } from 'customer-components/lib/types';
  import { getContext } from 'svelte';
  import { Menu01, X } from 'icons';
  export let properties: Header;
  export let settings: MktSettings;

  // Null by default so the closing animation doesn't run on initial load
  let isMobileMenuOpen: boolean | null = null;

  $: ({ button, text, icon } = properties);
  $: ({ logo, businessName, menu } = settings);

  const city = getContext<Object>('city');
</script>

<header class="nav py-4">
  <div class="wrapper">
    <div class="flex items-center gap-2">
      {#if menu?.active && menu?.links?.length > 0}
        <span class="mobile-nav-list-trigger">
          <button
            class="nav-button"
            on:click={() => (isMobileMenuOpen = !isMobileMenuOpen)}
          >
            <Menu01 />
          </button>
        </span>
      {/if}
      {#if logo.value}
        <img class="logo" src={logo?.value} alt="logo" />
      {:else}
        <span class="text-left text-lg font-bold !text-[var(--color-primary)]"
          >{@html businessName}</span
        >
      {/if}
    </div>

    {#if menu?.active && menu?.links?.length > 0}
      <ul
        class="nav-list"
        class:isMobileMenuOpen
        class:isMobileMenuClose={isMobileMenuOpen === false}
      >
        {#each menu.links as link}
          <li class="nav-item">
            <a
              class="nav-link"
              href={link.value}
              on:click={() => (isMobileMenuOpen = !isMobileMenuOpen)}
            >
              {@html link.label}
            </a>
          </li>
        {/each}
        <button
          class="mobile-nav-list-close flex items-center gap-1"
          on:click={() => (isMobileMenuOpen = !isMobileMenuOpen)}
          ><X /> Close</button
        >
      </ul>
    {/if}

    <div class="area">
      <p class="area-text">
        {@html text?.value}
      </p>
      {#if button?.active}
        <a class="primary-button" href={getHref(button.link_type, button.link)}>
          {#if icon?.active}
            <BulletPoint bulletIcon={icon?.value} />
          {/if}
          {@html button?.label}
        </a>
      {/if}
    </div>
  </div>
</header>
